import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';

import './index.sass';
import { Skeleton } from '@mui/material';
import Model from '../../../model';
import SimpleEventChip from 'components/OrderDetails/SimpleEventChip';
import { useMobile } from 'utils/media';
import Details from 'components/Details';
import { TextWithPulsingDot } from 'components/TextWithPulsingDot';
import { GreenText } from 'components/GreenText';

const { block, el } = bem('order-details');

const OrderDetails = ({ events, EventChip = SimpleEventChip, ...rest }) => {

    const { isMobile } = useMobile();
    const eventSort = (a, b) => {
        return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    }

    return (
        <div className={ block() }>
            { !isMobile && <OrderInfo {...rest} /> }
            <div className={ el('events-block') }>
                <div className={ el('events-list') }>
                    { events.sort(eventSort).map((event, i) => <EventChip key={i} event={event} number={i} />) }
                </div>
            </div>
            { isMobile && <Details>
                <OrderInfo {...rest} />
            </Details>}
        </div>
    )
}

const OrderInfo = (props) => {
    const { problem, workingOfflineText, workingOffline, workingWithPairs, city, district, skype, address } = props;
    const problemText = problem ? problem : 'Психологическое консультирование';
    const typeText = workingOfflineText;
    const pairText = workingWithPairs ? ', ' + 'работа с парой' : '';
    const cityText = `${ city ? city : 'Город не важен' }${ city && district ? ', ' + district : '' }`;
    const copySkypeToClipboard = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!skype) { return; }
        navigator.clipboard.writeText(skype)
            .then(() => {
                console.log('Content copied to clipboard');
            })
            .catch(() => {
                console.error('Failed to copy');
            });
    };
    const { openSpecialistAddressInfo } = Model.modal;
    const openSpecialistAddress = () => {
        openSpecialistAddressInfo(address)
    }

    return (
        <div className={ el('details') }>
            { problem && <div className={ el('detail') }>
                <div className={ el('detail-label') }>
                    <Text>Запрос</Text>
                </div>
                <div className={ el('detail-value') }>
                    <Text>{ problemText }</Text>
                </div>
            </div> }
            <div className={ el('detail') }>
                <div className={ el('detail-label') }>
                    <Text>Тип</Text>
                </div>
                <div className={ el('detail-value') }>
                    <Text>{ typeText }{ pairText }</Text>
                </div>
            </div>
            { workingOffline && <div className={ el('detail') }>
                <div className={ el('detail-label') }>
                    <Text>Город</Text>
                </div>
                <div className={ el('detail-value') }>
                    <Text>{ cityText }</Text>
                </div>
            </div> }
            { skype && <div className={ el('detail') }>
                <div className={ el('detail-label') }>
                    <Text>Skype</Text>
                </div>
                <div className={ el('detail-value') }>
                    <Text>{ skype }</Text>
                    <Icon name={ 'copy' } onClick={ copySkypeToClipboard }/>
                </div>
            </div> }
            { address && <div className={ el('detail', 'address') }>
                <div className={ el('detail-label') }>
                    <Text>Адрес</Text>
                </div>
                <div className={ el('detail-value') }>
                    <Text>{address.address}</Text>
                    <div className={ el('scheme') } onClick={ openSpecialistAddress }>
                        <Icon name={ 'map-trifold' }/>
                        <Text>Схема проезда</Text>
                    </div>
                </div>
            </div> }
        </div>
    )
}

export const OrderDetailsSkeleton = () => {
    return (
        <div className={ block() }>
            <div className={ el('details') }>
                <div className={ el('detail') }>
                    <div className={ el('detail-label') }>
                        <Skeleton><Text>Запрос</Text></Skeleton>
                    </div>
                    <div className={ el('detail-value') }>
                        <Text><Skeleton width={ 100 }/></Text>
                    </div>
                </div>
                <div className={ el('detail') }>
                    <div className={ el('detail-label') }>
                        <Skeleton><Text>Тип</Text></Skeleton>
                    </div>
                    <div className={ el('detail-value') }>
                        <Text><Skeleton width={ 200 }/></Text>
                    </div>
                </div>
                <div className={ el('detail') }>
                    <div className={ el('detail-label') }>
                        <Skeleton><Text>Город</Text></Skeleton>
                    </div>
                    <div className={ el('detail-value') }>
                        <Text><Skeleton width={ 150 }/></Text>
                    </div>
                </div>
                <div className={ el('detail') }>
                    <div className={ el('detail-label') }>
                        <Skeleton><Text>Skype</Text></Skeleton>
                    </div>
                    <div className={ el('detail-value') }>
                        <Text><Skeleton width={ 100 }/></Text>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderDetails;
